import { render, staticRenderFns } from "./risk-group-modal.vue?vue&type=template&id=8901233c&scoped=true"
import script from "./risk-group-modal.vue?vue&type=script&lang=js"
export * from "./risk-group-modal.vue?vue&type=script&lang=js"
import style0 from "./risk-group-modal.vue?vue&type=style&index=0&id=8901233c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8901233c",
  null
  
)

export default component.exports